import React, { useEffect, useState } from 'react';
import { StatusTip } from 'tea-component';
import './index.scss';

/**
 * 图片渲染组件
 * @param  coverImage     实际图片
 * @param  className      样式名称
 * @param  onClick        点击事件
 * @param  defaultImage   默认图片
 * @returns
 */
export default function RenderImg({
  coverImage,
  className = '',
  onClick,
  setLoading = () => {},
  defaultImage,
  style,
  mode = 'backgroundImage',
  box = false,
}: {
  coverImage: string;
  className?: string;
  onClick?: (e) => void;
  setLoading?: (loading: boolean) => void;
  defaultImage?: string;
  style?: React.CSSProperties;
  mode?: 'backgroundImage' | 'image';
  box?: boolean;
}) {
  const [imageLoading, setImageLoading] = useState(true);
  const [imageError, setImageError] = useState(false);
  function changeLoading(value: boolean) {
    setLoading(value);
    setImageLoading(value);
  }
  const status = imageLoading ? 'loading' : imageError ? 'error' : '';

  function retry() {
    loadImg();
  }

  function loadImg() {
    if (!coverImage) {
      changeLoading(false);
      setImageError(true);
      return;
    }

    const curImage = new Image();
    curImage.src = coverImage;
    curImage.onload = () => {
      changeLoading(false);
      setImageError(false);
    };
    curImage.onerror = () => {
      changeLoading(false);
      setImageError(true);
    };
  }

  useEffect(() => {
    loadImg();
  }, [coverImage]);

  const renderImg = () => {
    if (mode === 'backgroundImage') {
      return (
        <div
          className={`${className} ${
            imageLoading || imageError ? 'default-img' : ''
          }`}
          onClick={(e) => {
            if (onClick) {
              e.stopPropagation();
              onClick?.(e);
            }
          }}
          style={{
            backgroundImage: `url("${
              imageLoading || imageError ? defaultImage : coverImage
            }")`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            cursor: onClick ? 'pointer' : 'default',
            ...style,
          }}
        ></div>
      );
    }
    return (
      <img
        className={`${className} ${
          imageLoading || imageError ? 'default-img' : ''
        }`}
        onClick={(e) => {
          e.stopPropagation();
          onClick?.(e);
        }}
        src={imageLoading || imageError ? defaultImage : coverImage}
        style={{
          cursor: onClick ? 'pointer' : 'default',
          ...style,
        }}
      />
    );
  };

  if (box) {
    return status ? (
      <div
        style={{
          display: 'flex',
          width: '100%',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        className = "db-studio-render-img"
      >
        <StatusTip
          className="dbo-render-img-status-tip"
          hideIcon={!imageLoading}
          status={status}
          onRetry={() => {
            changeLoading(true);
            setImageError(false);

            retry();
          }}
          errorText="Data loading failed, "
          retryText="click to reload"
          loadingText=""
        />
      </div>
    ) : (
      renderImg()
    );
  }
  return <>{renderImg()}</>;
}
